import { RSAA, getJSON, ApiError } from 'redux-api-middleware';
import { userAccountIsUnauthenticatedSelector as isUnauthenticatedSelector } from '../selectors/isUnauthenticated';
import { REGISTER_WITH_EMAIL } from './types';

const paramsToBody = ({ firstName, email, password, birthday }) => ({
  name: {
    givenName: firstName,
    familyName: '',
  },
  email: email.toLowerCase(),
  password,
  compare_password: password,
  birthday,
  referrer: 'web',
  preferences: {
    optIn: true,
  },
  synced: false,
});

const parseErrors = (errors) => {
  if (!Array.isArray(errors)) {
    return errors;
  }

  return errors.map((err) => {
    if (err.param === 'name.givenName') {
      return {
        ...err,
        param: 'firstName',
      };
    }

    return err;
  });
};

const requestApiAction = (params) => ({
  [RSAA]: {
    endpoint: '/v1/user',
    method: 'POST',
    credentials: 'include',
    body: paramsToBody(params),
    types: [
      REGISTER_WITH_EMAIL.REQUEST,
      REGISTER_WITH_EMAIL.SUCCESS,
      {
        type: REGISTER_WITH_EMAIL.FAILURE,
        payload: (action, state, res) =>
          getJSON(res).then((err) => new ApiError(res.status, res.statusText, parseErrors(err))),
      },
    ],
  },
});

/*
See https://stackoverflow.com/a/201378 and https://emailregex.com/#javascript
for a discussion on the regexp.
*/
const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// According to https://github.com/Pluto-tv/inf-lib-schemas/blob/v2.4.0/schemas/user/schema.js
const firstNameRegex = /^[-\sA-zÀ-ÿ]+$/;

const verifyParams = ({ email, password, birthday, firstName }) => {
  const response = [];
  if (!emailRegex.test(email)) {
    response.push({
      param: 'email',
      msg: 'Enter a valid email address',
      value: email,
    });
  }

  // public-api validation constraints: https://github.com/Pluto-tv/public-api/blob/1720648aa390e724fabf09d36dc41a3f86e2b411/app/controllers/v1/user/validator.js#L42
  if (!password || password.length < 6 || password.length > 20) {
    response.push({
      param: 'password',
      msg: 'Enter a password that is 6-20 characters',
      value: password,
    });
  }

  if (!(birthday instanceof Date) || Number.isNaN(birthday)) {
    response.push({
      param: 'birthday',
      msg: 'Select your birth year',
      value: birthday,
    });
  }

  if (firstName) {
    let msg;
    if (firstName.length < 2) {
      msg = 'Must be at least 2 characters';
    } else if (!firstNameRegex.test(firstName)) {
      msg = 'Must not be special characters';
    }

    if (msg) {
      response.push({
        param: 'firstName',
        msg,
        value: firstName,
      });
    }
  }

  if (response.length > 0) {
    return new ApiError(409, 'Conflict', response);
  }
  return false;
};

export const userAccountRegisterWithEmailThunkAction = (params) => async (dispatch, getState) => {
  const isUnauthenticated = isUnauthenticatedSelector(getState());
  if (isUnauthenticated) {
    const err = verifyParams(params);
    if (!err) {
      await dispatch(requestApiAction(params));
    } else {
      await dispatch({ type: REGISTER_WITH_EMAIL.FAILURE, payload: err });
    }
  }
};
